import React from "react";
import {withNamespaces} from "react-i18next";
import {modalActions} from "../actions/modal.actions";
import {connect} from "react-redux";
import {networkDeviceContentActions} from "../actions/network-device-content.actions";

const CheckboxDefaultContent = ({t, contentModel, showModal, hideModal, setIsDefault}) => {

    const openConfirmModal = (contentModel) => {
        showModal({
            open: true,
            title: t('are-you-sure'),
            message: `<p>${t('network-device-content-set-default-msg')}</p><p><b>${contentModel.label}</b></p>`,
            confirmLabel: t('OK'),
            confirmIcon: 'fa-check-circle',
            classNameBtnConfirm: 'btn-info',
            dataId: contentModel,
            confirmAction: (model) => {
                setIsDefault(model);
                hideModal();
            },
            closeModal: closeModal,
        }, 'confirm')
    };

    const closeModal = () => {
        hideModal()
    };

    return (
        <input
            type="checkbox"
            checked={contentModel.isDefault}
            disabled={!!contentModel.isDefault }
            onChange={() => openConfirmModal(contentModel)}
        />
    )
};

const mapDispatchToProps = dispatch => ({
    setIsDefault: (contentModel) => dispatch(networkDeviceContentActions.setDefaultContent(contentModel)),
    hideModal: () => dispatch(modalActions.hideModal()),
    showModal: (modalProps, modalType) => {
        dispatch(modalActions.showModal({ modalProps, modalType }))
    }
});

export default withNamespaces()(connect(null, mapDispatchToProps)(CheckboxDefaultContent));
